<template>
  <div
    class="skeleton-block"
    :class="{ 'is-rounded': rounded }"
    :style="blockStyle"
    aria-hidden="true"
  />
</template>

<script>
export default {
  name: "SkeletonBlock",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "16px",
    },
    rounded: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    blockStyle() {
      return {
        width: this.width,
        height: this.height,
      };
    },
  },
};
</script>

<style scoped>
.skeleton-block {
  position: relative;
  overflow: hidden;
  background: linear-gradient(90deg, #eef3f8 0%, #f8fbfd 50%, #eef3f8 100%);
  background-size: 200% 100%;
  animation: skeletonShift 1.3s ease-in-out infinite;
}

.is-rounded {
  border-radius: 999px;
}

@keyframes skeletonShift {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
